<script>
import Slideout from "vue-slideout";
import MobileMenu from "./components/mobile-menu.vue";
import MainWrap from "./components/main-wrap.vue";
import { mapActions } from "vuex";
export default {
	name: "app",
	components: {
		Slideout,
		MobileMenu,
		MainWrap
	},
	mounted() {
		this.getMain();
		//console.log(this);
	},
	methods: {
		...mapActions({
			getMain: "main/getMain"
		}),
		open: function() {
			//console.log("slideoutOpen");
		}
	}
};
</script>

<template lang="pug">
	#app
		button(class="toggle-button") ☰	
		Slideout(menu="#menu" panel="#panel" :toggleSelectors="['.mobile-menu__register', '.toggle-button', '.sidebar-toggle:first-child', '.sidebar-toggle:nth-child(2)', '.sidebar-toggle:nth-child(3)', '.sidebar-toggle:nth-child(4)', '.sidebar-toggle:nth-child(5)']" @on-open="open")
			mobile-menu
			main-wrap


</template>

<style lang="stylus">
body
	width 100%
	height 100%
	margin 0
	font-family Roboto

h1, h2
	font-family Oswald
	text-transform uppercase
	font-size 30px
	padding 0 0 20px 0
	margin 0
	color #5b575d
	@media screen and (max-width: 1000px)
		text-align center
		padding: 0 40px 20px;

h2
	font-size 24px

p
	font-size 18px
	line-height 1.6em
	padding 0 0 30px
	margin 0
	box-sizing border-box

button.toggle-button
	top 10px
	left 10px
	font-size 36px
	border none
	background none
	outline none
	z-index 20
	color white
	text-shadow 1px 1px 1px rgba(0, 0, 0, .1)
	position fixed
	background rgba(0,0,0,0.2);
	width 50px
	height 50px
	border-radius 25px
	line-height 1em

	@media screen and (min-width: 1000px)
		display none

.slideout-open button.toggle-button
	display none
</style>
